import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: 'Credit Up Benefits',
    mainDesc: 'By increasing the credit limit of the loan in Smart Credit, you can get:',
    title1: 'Better loan offers',
    title2: 'Exclusive vouchers',
    title3: 'Get Exclusive Deal',
    title4: 'Higher loan limit',
    desc1: 'Get up to Rp 50 million loan limit with flexible tenor and lower interest rate.',
    desc2: 'Get vouchers up to Rp 500.000.',
    desc3: 'Subscribe for Exclusive Voucher and Promo, tips and news.',
    desc4: 'Get a loan of up to Rp 50 million with flexible tenor and low interest.',
  },
  id: {
    title: 'Manfaat Peningkatan Kredit',
    mainDesc: 'Dengan meningkatkan kredit limit pinjaman di Kredit Pintar, Anda bisa mendapatkan:',
    title1: 'Limit pinjaman lebih tinggi',
    title2: 'Voucher eksklusif',
    title3: 'Dapatkan penawaran spesial',
    title4: 'Limit pinjaman Lebih tinggi',
    desc1: 'Dapatkan pinjaman hingga Rp 50 juta dengan tenor fleksibel dan bunga rendah.',
    desc2: 'Dapatkan voucher eksklusif hingga Rp 500.000.',
    desc3: 'Subscribe untuk dapatkan voucher & promo eksklusif dari Kredit Pintar.',
    desc4: 'Dapatkan pinjaman hingga 50 juta rupiah dengan tenor fleksibel dan bunga rendah.',
  },
})

const Benefit = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const BenefitsList = [
    {
      img: '/images/product/benefit1.png',
      title: t('title1'),
      desc: t('desc1'),
    },
    {
      img: '/images/product/benefit2.png',
      title: t('title2'),
      desc: t('desc2'),
    },
    {
      img: '/images/product/benefit3.png',
      title: t('title3'),
      desc: t('desc3'),
    },
    {
      img: '/images/product/benefit4.png',
      title: t('title4'),
      desc: t('desc4'),
    },
  ]
  return (
    <Whys>
      <div className="title">{t('title')}</div>
      <div className="main-desc">{t('mainDesc')}</div>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          BenefitsList.map((item, index) => (
            <Reveal key={index} delay={200 + index * 120} animation={Animation.FadeIn}>
              <div className="item">
                <div className="img">
                  <LazyLoad>
                    <img src={item.img} alt={item.title} />
                  </LazyLoad>
                </div>
                <div className="subtitle">{item.title}</div>
                <div className="desc">{item.desc}</div>
              </div>
            </Reveal>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }} scrollbar={{ draggable: true }}>
            {BenefitsList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <LazyLoad>
                      <img src={item.img} alt={item.title} />
                    </LazyLoad>
                  </div>
                  <div className="subtitle">{item.title}</div>
                  <div className="desc">{item.desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </Whys>
  )
}

export default Benefit

const Whys = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 40px auto;
    text-align: center;
    width: 100%;
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      width: 272px;
      margin: 0 auto 12px;
    }
    .main-desc {
      display: none;
    }
    .items {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      .item {
        margin: 0 auto;
        width: 272px;
        min-height: 376px;
        text-align: center;
        background-color: #f1fcf6;
        border-radius: 8px;
        .img {
          width: 168px;
          height: 168px;
          margin: 16px auto 18px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 16px 150px 132px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 40px;
    }
    .main-desc {
      font-size: 16px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #9e9e9e;
      line-height: 32px;
      padding-bottom: 48px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        width: 264px;
        height: 440px;
        text-align: center;
        background-color: #f1fcf6;
        border-radius: 8px;
        .img {
          width: 168px;
          height: 168px;
          margin: 48px;
          margin-bottom: 32px;
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
  .subtitle {
    font-size: 24px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #212121;
    line-height: 24px;
  }
  .desc {
    padding-top: 12px;
    width: 212px;
    text-align: center;
    margin: 0 auto;
    font-size: 16px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #9e9e9e;
    line-height: 28px;
  }
`
